module.exports = __webpack_public_path__ + "pic/3.9694bc09.png";